import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { LayoutProps } from './layout.props';

import * as TagNames from './layouts.tagnames';

@customElement(TagNames.SimpleLayout)
export class AtlSimpleLayout extends LitElement implements LayoutProps {
    declare showEnvRibbon: boolean;
    declare envRibbonName: string;

    static properties = {
        showEnvRibbon: { type: Boolean },
        envRibbonName: { type: String },
    };

    constructor() {
        super();
        this.showEnvRibbon = false;
        this.envRibbonName = '';
    }

    static styles = [
        ...getGlobalStyleSheets(),
        css`
         :host {
             display: flex;
             flex-direction: column;
             min-height: 100vh;
         }

         ::slotted([slot=header]) {
            flex-shrink: 0;
         }

         ::slotted([slot=footer]) {
             flex-shrink: 0;
         }

         ::slotted([slot=body]) {
            flex-grow: 1;
         }
      `,
    ];

    render() {
        return html`
            <slot name="header"></slot>
            <slot name="body"></slot>
            <slot name="footer"></slot>
            <atlantis-environment-ribbon 
                ?show=${this.showEnvRibbon} 
                environment=${this.envRibbonName}
            >
            </atlantis-environment-ribbon>
      `;
    }
}
